import { Action } from '@ngrx/store';

export const DESTROY = '[Job Card Modal] Destroy';

export class DestroyAction implements Action {
    readonly type = DESTROY;
}



// WEBPACK FOOTER //
// ./src/app/molecules/job-card-modal/job-card-modal.actions.ts